<script>
    import { getContext } from "svelte";
    import { key as cinemaTileDimensionKey } from "../context/cinemaTileDimension";
    import DealBadge from "./DealBadge.svelte";

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        image,
        variationId = null,
        deal = null,
        lazyLoad = false,
        isVeryPopular = false,
        isBrand = false,
        featuresState = {},
        personalisedUser = false,
    } = $props();

    const { width: widthAmount, height: heightAmount } = getContext(cinemaTileDimensionKey);
    const { width, height } = { width: `${widthAmount}px`, height: `${heightAmount}px` };

    const MEDIUM_IMAGE_SIZE_PRESET = "$spa_ambiente$";
    const TILE_PORTRAIT_PRESET = "$tile_portrait$";
    const loadingValue = lazyLoad ? "lazy" : "eager";

    const buildImageUrl = (imageUrl, clippingType) => {
        const prefix = clippingType === "AMBIENTE" ? MEDIUM_IMAGE_SIZE_PRESET : TILE_PORTRAIT_PRESET;
        return imageUrl + "?" + prefix;
    };

    const imageSrc = buildImageUrl(image._links.external.href, image.clippingType);

    const showSponsored = deal?.imageUrl && deal?.clickable;
    const showDealIcon = deal?.imageUrl && !deal?.clickable;
</script>

<oc-card-v2>
    <div class="reco_cinema__image {isBrand ? 'reco_cinema__image__border_radius' : ''}" style:width style:height>
        <picture>
            <source srcset="{imageSrc}&fmt=auto" />
            <img
                loading={loadingValue}
                data-src={imageSrc}
                src={lazyLoad ? "" : imageSrc}
                alt={image.altText}
                class="{lazyLoad ? 'lazy' : ''} {image.clippingType === 'AMBIENTE' ? 'ambiente' : 'cutout'}"
                data-testid="image-title"
            />
        </picture>
        <div class="reco_cinema__image__spinner_box">
            <div class="reco_cinema__image__spinner {lazyLoad ? 'p_loader250' : ''}"></div>
        </div>
        {#if showSponsored || featuresState.ENABLE_SHEET_SERVICE_FOR_DEALBADGES}
            <DealBadge {deal} {variationId} {featuresState} {personalisedUser} />
        {:else if showDealIcon}
            <div
                role="paragraph"
                class="reco_cinema__image__badge reco_cinema__image__deal_badge"
                data-qa="dealIcon"
                style={"background: url(" + deal.imageUrl + ") center center/50px 50px no-repeat;"}
            >
                &nbsp;
            </div>
        {/if}
        <div class="reco_cinema__labels_wrapper">
            {#if isVeryPopular}
                <div class="reco_cinema__label-visibility reco_cinema__very-popular-tag">
                    <oc-tag-v1 size="50" variant="info-primary">Sehr beliebt</oc-tag-v1>
                </div>
            {/if}
        </div>
    </div>
</oc-card-v2>

<style lang="scss">
    .reco_cinema__image {
        text-align: center;
        padding-bottom: initial;
        position: relative;
        overflow: hidden;
        max-height: 100%;
        max-width: 100%;
        transform: translateZ(0);

        &__border_radius {
            border-radius: 12px;
        }

        img {
            max-width: 100%;
            max-height: 100%;
            z-index: 1;
            position: absolute;
            right: 50%;
            transform: translate(50%, 0);
        }

        img.ambiente {
            width: auto;
            height: auto;
            min-width: 100%;
            min-height: 100%;
            max-width: none;
        }

        img.cutout {
            padding: 8px;
            width: 100%;
        }
    }

    .reco_cinema__image__spinner_box {
        position: absolute;
        margin: auto;
        width: 60px;
        height: 60px;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 0;
    }

    .reco_cinema__image__deal_badge {
        position: absolute;
        width: 50px;
        height: 50px;
        z-index: 1;
        top: 8px;
        left: 16px;
    }

    /*                                                                                                                  */
    .reco_cinema__image__badge {
        background-size: cover;
    }

    .reco_cinema__labels_wrapper {
        display: flex;
        flex-direction: column;
        position: absolute;
        bottom: 16px;
        left: 16px;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .reco_cinema__label-visibility {
        z-index: 1;
    }

    .reco_cinema__very-popular-tag {
        margin-top: 8px;
    }
</style>
